import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const normalizeBucket = (value) => {
  if (!value) return value;
  // Some configs mistakenly set the download host (*.firebasestorage.app). Replace with bucket ID (*.appspot.com).
  if (value.includes('firebasestorage.app')) {
    const host = value.replace(/^https?:\/\//, '').split('/')[0];
    const bucketId = host.replace('.firebasestorage.app', '');
    const fixed = `${bucketId}.appspot.com`;
    console.warn('[Firebase] Ajustando storageBucket inválido', value, '->', fixed);
    return fixed;
  }
  return value;
};

// Firebase configuration using environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: normalizeBucket(process.env.REACT_APP_FIREBASE_STORAGE_BUCKET),
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Validate that all required environment variables are set
const requiredEnvVars = [
  'REACT_APP_FIREBASE_API_KEY',
  'REACT_APP_FIREBASE_AUTH_DOMAIN',
  'REACT_APP_FIREBASE_PROJECT_ID',
  'REACT_APP_FIREBASE_STORAGE_BUCKET',
  'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
  'REACT_APP_FIREBASE_APP_ID'
];

const missingEnvVars = requiredEnvVars.filter(envVar => !process.env[envVar]);
if (missingEnvVars.length > 0) {
  console.error('Missing required environment variables:', missingEnvVars);
  console.error('Please check your .env.local file and make sure all Firebase configuration variables are set.');
  throw new Error(`Missing environment variables: ${missingEnvVars.join(', ')}`);
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };

